import Address from "@/models/Address";
import Workplace from "@/models/Workplace";

export default class FamilyMember {
  constructor() {
    this.clear();
  }

  isEmpty(obj = this) {
    for (const attr in obj) {
      if (!obj[attr]) continue;

      if (!(typeof obj[attr] === "object") || !obj.isEmpty(obj[attr]))
        return false;
    }

    return true;
  }

  clear() {
    this.nome = null;
    this.kinship = {};
    this.income = null;
    this.cpf = null;
    this.certidaoNascimento = null;
    this.pisPasep = null;

    this.workplace = new Workplace();

    this.endereco = new Address();
  }
}
